/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  VOUCHER_BY_SALES,
  VOUCHER_BY_SALES_PERIOD,
  TIER_COMMISSION_SUMMARY,
  SELECTED_COMM_PERIOD,
  VOUCHER_BY_SALES_CLEAR,
  SALES_PERIODS,
  SELECTED_SALES_TEAM_MEMBER,
  SELECTED_SALES_PERIOD,
  MTR_SALES_SUMMARY,
  CLEAR_SALES_SUMMARY,
  MTR_NAVIGATATION_KEY_DATA,
  CLEAR_COMM_VOUCHER_DATA,
  TTM_VIEW,
  SHARED_SELECTED_REPORT_TYPE,
  SHARED_SELECTED_SALES_MANAGER,
  SHARED_SALES_REP_CHANNEL,
  SHARE_MANAGER_SELECTED_SALES_PERIOD,
  SET_SHARED_SALES_TEAM
} from '../actions/insightQoreAction';
import { aboveQuotaGrowthRateRule, underPerformingGrowthRateRule, concernGrowthRateRule, unremittedGrowthRateRule } from '../views/sales/commission-voucher/rules/TierBuckectsCalc';
import { convertToPascalCaseWithSpaces } from 'src/utils/string';


const initialState = {
  salesFilterData: [],
  salesPersonList: [],
  salesPeriodList: [],
  tieredCommissionList: [],
  isLoadingData: false,
  selectedCommPeriod: null,
  mtrNavigationData: null,

  commissionVoucherDataGrowthRateGreen: [],
  commissionVoucherDataGrowthRateYellow: [],
  commissionVoucherDataGrowthRateRed: [],
  commissionVoucherDataGrowthRateUnRemitted: [],
  commissionVoucherDataGrowthRateFull: [],

  shared_commission_voucher_data: [],
  shared_sales_team: [],
  shared_sales_periods: [],
  shared_selected_sales_team_member: '',
  shared_selected_sales_period: '',
  has_user_selected_period: false, // Track if user/system has explicitly selected a period
  shared_selected_report_type: null,
  shared_selected_sales_manager: '',

  shared_mtr_sales_summary_data: [],
  shared_mtr_sales_summary_80data: [],
  shared_mtr_sales_summary_20data: [],

  team_member_override: null,
  ttm_view: false,

  shared_sales_rep_channel: null,
  shared_manager_selected_sales_period: null,
};

const insightQoreReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MTR_NAVIGATATION_KEY_DATA: {
      const navData = payload;
      return produce(state, draft => {
        draft.mtrNavigationData = navData;
      });
    }

    case VOUCHER_BY_SALES_CLEAR: {
      return produce(state, draft => {
        draft.commissionVoucherDataGrowthRateFull = [];
        draft.commissionVoucherDataGrowthRateGreen = [];
        draft.commissionVoucherDataGrowthRateYellow = [];
        draft.commissionVoucherDataGrowthRateRed = [];
        draft.commissionVoucherDataGrowthRateUnRemitted = [];

      });
    }
    case VOUCHER_BY_SALES: {

      const selectedSalesPeriod = payload.period;
      const override = payload.override || null;
      const tiers = payload.tiers || null;
      const initialResponse = payload.salesData;


      const greenGrowthRate = aboveQuotaGrowthRateRule(initialResponse, selectedSalesPeriod.attributes, override, tiers);
      const amberGrowthRate = underPerformingGrowthRateRule(initialResponse, selectedSalesPeriod.attributes, override, tiers);
      const redGrowthRate = concernGrowthRateRule(initialResponse, selectedSalesPeriod.attributes, override, tiers);
      const unremittedGrowthRate = unremittedGrowthRateRule(initialResponse, selectedSalesPeriod.attributes, override, tiers);


      return produce(state, draft => {
        //    draft.salesFilterData = salesFilterData;
        draft.selectedCommPeriod = selectedSalesPeriod;
        draft.commissionVoucherDataGrowthRateFull = initialResponse;
        draft.commissionVoucherDataGrowthRateGreen = greenGrowthRate;
        draft.commissionVoucherDataGrowthRateYellow = amberGrowthRate;
        draft.commissionVoucherDataGrowthRateRed = redGrowthRate;
        draft.commissionVoucherDataGrowthRateUnRemitted = unremittedGrowthRate;
      });
    }

    case VOUCHER_BY_SALES_PERIOD: {
      const commissionVoucherDataWithSalesMembers = payload;

      return produce(state, draft => {

        let mergedMembers = commissionVoucherDataWithSalesMembers.uniqueSalesRep;

        draft.salesFilterData =
          commissionVoucherDataWithSalesMembers.salesCommissionData;

        draft.salesPersonList =
          mergedMembers;

        draft.shared_commission_voucher_data =
          commissionVoucherDataWithSalesMembers.salesCommissionData;


        draft.shared_sales_team = [
          'Select Sales Person',
          ...mergedMembers
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((member) => {
              const formattedName = convertToPascalCaseWithSpaces(member.name);
              return member.channel ? `${formattedName} [${member.channel}]` : formattedName;
            })
        ];

      });
    }

    case TIER_COMMISSION_SUMMARY: {
      const tieredCommissionList = payload;
      return produce(state, draft => {
        draft.tieredCommissionList = tieredCommissionList;
      });
    }
    case SELECTED_COMM_PERIOD: {
      return produce(state, draft => {
        draft.selectedCommPeriod = payload;
      });
    }
    case SELECTED_SALES_TEAM_MEMBER: {
      return produce(state, draft => {
        draft.shared_selected_sales_team_member = payload;
      });
    }

    case SALES_PERIODS: {
      return produce(state, draft => {
        draft.shared_sales_periods = payload;
      });
    }

    case SELECTED_SALES_PERIOD: {
      return produce(state, draft => {
        draft.shared_selected_sales_period = payload;
        // Mark that a period has been explicitly selected
        if (payload) {
          draft.has_user_selected_period = true;
        }
      });
    }

    case SHARED_SELECTED_REPORT_TYPE: {
      return produce(state, draft => {
        draft.shared_selected_report_type = payload;
      });
    }

    case SHARED_SELECTED_SALES_MANAGER: {
      return produce(state, draft => {
        draft.shared_selected_sales_manager = payload;
      });
    }

    case SHARED_SALES_REP_CHANNEL: {
      return produce(state, draft => {
        draft.shared_sales_rep_channel = payload;
      });
    }

    case SHARE_MANAGER_SELECTED_SALES_PERIOD: {
      return produce(state, draft => {
        draft.shared_manager_selected_sales_period = payload;
      });
    }

    case MTR_SALES_SUMMARY: {
      return produce(state, draft => {
        draft.shared_mtr_sales_summary_data = payload.result;
        draft.shared_mtr_sales_summary_80data = payload.grossProfit80Data;
        draft.shared_mtr_sales_summary_20data = payload.grossProfit20Data;
      });
    }

    case CLEAR_SALES_SUMMARY: {
      return produce(state, draft => {
        draft.shared_mtr_sales_summary_data = [];
        draft.shared_mtr_sales_summary_80data = [];
        draft.shared_mtr_sales_summary_20data = [];
      });
    }

    case CLEAR_COMM_VOUCHER_DATA: {
      return produce(state, draft => {
        draft.shared_commission_voucher_data = [];
      });
    }


    case TTM_VIEW: {
      return produce(state, draft => {
        draft.ttm_view = payload;

      });
    }

    case SET_SHARED_SALES_TEAM: {
      return produce(state, draft => {
        draft.shared_sales_team = payload;
      });
    }

    default: {
      return state;
    }
  }
};

export default insightQoreReducer;
